module.exports = __webpack_public_path__ + "static/media/icone-googlePlay.9899d100.svg";